import { StrictMode } from 'react'; import { createRoot } from 'react-dom/client'; import App from './App'; import './styles/variables.css'; import './styles/reset.css'; import './styles/global.css';
createRoot(document.getElementById('root')!).render(<StrictMode><App/></StrictMode>);
